import { IHomeImage } from '../../../interfaces/HomeImage.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

interface getHomeImagessParams {
  searchParam: {
    category: 'CAROUSEL_MAIN' | 'CAROUSEL_SUB';
  };
}

export const getHomeImages = ({ searchParam }: getHomeImagessParams): Promise<IHomeImage[]> => {
  const URLSearchParams = createURLSearchParams(searchParam);

  return customAxios.get(`/home/images?${URLSearchParams}`);
};
